import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ProtectedRoute = ({ children, requiredRole }) => {
    const { adminUser, memberUser, isAppReady } = useApp();
    const location = useLocation();

    if (!isAppReady) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    // STRICT TAB ISOLATION: Check if this tab is claimed by a different role
    const activeTabRole = sessionStorage.getItem('pci_active_role');

    if (activeTabRole && requiredRole && activeTabRole !== requiredRole) {
        // This tab is claimed by the OTHER role. Redirect to that role's dashboard.
        // This prevents an Admin tab from accessing Member routes and vice-versa.
        const properDashboard = activeTabRole === 'admin' ? '/admin' : '/member';
        return <Navigate to={properDashboard} replace />;
    }

    const currentUser = requiredRole === 'admin' ? adminUser : memberUser;

    if (!currentUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredRole && currentUser.role !== requiredRole) {
        return <Navigate to={currentUser.role === 'admin' ? '/admin' : '/member'} replace />;
    }

    return children;
};

export default ProtectedRoute;
